import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel"]

  connect() {
    this.detectOS()
  }

  detectOS() {
    const isWindows = /Win/i.test(navigator.userAgent)

    // Hide Homebrew tab on Windows
    this.tabTargets.forEach(tab => {
      if (isWindows && tab.dataset.terminalTab === "homebrew") {
        tab.style.display = "none"
      }
    })

    // Toggle OS-specific command lines
    this.element.querySelectorAll("[data-os]").forEach(el => {
      if (isWindows) {
        el.style.display = el.dataset.os === "windows" ? "" : "none"
      } else {
        el.style.display = el.dataset.os === "unix" ? "" : "none"
      }
    })
  }

  switchTab(event) {
    const tabName = event.currentTarget.dataset.terminalTab

    this.tabTargets.forEach(tab => {
      tab.classList.toggle("is-active", tab.dataset.terminalTab === tabName)
    })

    this.panelTargets.forEach(panel => {
      panel.classList.toggle("is-active", panel.dataset.terminalPanel === tabName)
    })
  }

  async copyLine(event) {
    const btn = event.currentTarget
    const line = btn.closest(".terminal-line") || btn.closest(".terminal-inline")
    const command = line.querySelector("[data-command]")
    if (!command) return

    const text = command.textContent.trim()

    try {
      await navigator.clipboard.writeText(text)
    } catch {
      const textarea = document.createElement("textarea")
      textarea.value = text
      textarea.style.position = "fixed"
      textarea.style.opacity = "0"
      document.body.appendChild(textarea)
      textarea.select()
      document.execCommand("copy")
      document.body.removeChild(textarea)
    }

    this.showCopyFeedback(btn)
  }

  showCopyFeedback(btn) {
    btn.classList.add("is-copied")

    setTimeout(() => {
      btn.classList.remove("is-copied")
    }, 2000)
  }
}
